import React from "react";

class AccountHeader extends React.Component {
    render() {
        return (
            <>
                

            </>
        );
    }
}

export default AccountHeader;